export default "__VITE_ASSET__143fb5de__"